import {
    BarChart3,
    Coins,
    Grid3x3,
    LayoutDashboard,
    MessagesSquare,
    Network,
    Timer,
    UserPlus,
    Users,
} from "lucide-react";

export const NAV_GROUPS = [
    {
        label: "Main",
        items: [
            { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, end: true },
            { to: "/dashboard/team", label: "Team", icon: Users },
            { to: "/dashboard/partners", label: "Partners", icon: UserPlus },
            { to: "/dashboard/affiliate", label: "Affiliate", icon: Network },
            { to: "/dashboard/stats", label: "Stats", icon: BarChart3 },
            { to: "/dashboard/matrix", label: "Matrix", icon: Grid3x3 },
        ],
    },
    {
        label: "Ecosystem",
        items: [
            { to: "/dashboard/marathon", label: "Marathon", icon: Timer },
            { to: "/dashboard/social", label: "Social", icon: MessagesSquare },
            { to: "/dashboard/tokens", label: "Tokens", icon: Coins },
        ],
    },
];

export const PAGE_TITLES = {
    "/dashboard": "Dashboard",
    "/dashboard/team": "Team",
    "/dashboard/partners": "Partners",
    "/dashboard/affiliate": "Affiliate",
    "/dashboard/stats": "Stats",
    "/dashboard/matrix": "Matrix",
    "/dashboard/marathon": "Marathon",
    "/dashboard/social": "Social",
    "/dashboard/tokens": "Tokens",
    "/dashboard/activity": "Activity",
};
